class CartProductRecommendationsDesktop extends HTMLElement {
  constructor() {
    super();
    this.abortController = null;
    this.observer = null;
    this.cartDrawer = null;
    this.hasContent = false;
  }

  connectedCallback() {
    const productId = this.dataset.productId;
    const sectionId = this.dataset.sectionId;
    const target = this.dataset.target;
    const limit = this.dataset.limit || 4;
    const intent = this.dataset.intent || 'related';

    this.setupDrawerObserver();

    const existingContainer = target ? this.querySelector(`[class*="${target}"]`) : null;

    if (existingContainer && existingContainer.innerHTML.trim().length > 0) {
      this.hasContent = true;
      this.updateActiveState();
      return;
    }

    if (!productId || !sectionId || !target) {
      this.hasContent = false;
      this.style.display = 'none';
      this.updateActiveState();
      return;
    }

    this.fetchRecommendations(productId, sectionId, target, limit, intent);
  }

  disconnectedCallback() {
    if (this.abortController) {
      this.abortController.abort();
    }

    if (this.observer) {
      this.observer.disconnect();
    }
  }

  setupDrawerObserver() {
    this.cartDrawer = document.querySelector('.cart-drawer-sheet-content');

    if (!this.cartDrawer) {
      return;
    }

    this.observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'data-state') {
          this.updateActiveState();
        }
      });
    });

    this.observer.observe(this.cartDrawer, {
      attributes: true,
      attributeFilter: ['data-state'],
    });

    this.updateActiveState();
  }

  updateActiveState() {
    if (!this.cartDrawer) {
      return;
    }

    const isDrawerOpen = this.cartDrawer.getAttribute('data-state') === 'open';

    if (isDrawerOpen && this.hasContent) {
      this.classList.add('active');
    } else {
      this.classList.remove('active');
    }
  }

  async fetchRecommendations(productId, sectionId, target, limit, intent) {
    this.abortController = new AbortController();

    try {
      const url = `${window.Shopify.routes.root}recommendations/products?product_id=${productId}&limit=${limit}&section_id=${sectionId}&intent=${intent}`;

      const response = await fetch(url, { signal: this.abortController.signal });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const text = await response.text();
      const html = new DOMParser().parseFromString(text, 'text/html');

      const recommendations = html.querySelector(`.${target}`);

      if (recommendations && recommendations.innerHTML.trim().length > 0) {
        this.innerHTML = recommendations.innerHTML;
        this.hasContent = true;
        this.style.display = '';
        this.updateActiveState();
      } else {
        this.hasContent = false;
        this.style.display = 'none';
        this.updateActiveState();

        this.dispatchEvent(
          new CustomEvent('cart-recommendations-desktop:empty', {
            bubbles: true,
            detail: { productId },
          }),
        );
      }
    } catch (error) {
      if (error.name === 'AbortError') {
        return;
      }

      this.hasContent = false;
      this.style.display = 'none';
      this.updateActiveState();

      this.dispatchEvent(
        new CustomEvent('cart-recommendations-desktop:error', {
          bubbles: true,
          detail: { error, productId },
        }),
      );
    }
  }
}

if (!customElements.get('cart-product-recommendations-desktop')) {
  customElements.define('cart-product-recommendations-desktop', CartProductRecommendationsDesktop);
}
